import React, { useEffect, useMemo, useState } from "react";
import {
  StreetFeatureDropdownOption,
  SystemDistrict,
  UserSex,
} from "../../../../utils/enums";
import { Select } from "../../../Select";
import { ReactSelect } from "../../../ReactSelect";

import map from "lodash.map";
import Form from "react-bootstrap/lib/Form";
import { Formik } from "formik";
import { UserVoteSchema } from "../../../../validators/user";
import { useFetch } from "../../../../hooks/use-fetch";
import {
  peselValidator,
  getBirthdateFromPesel,
} from "../../../../validators/common";
import "../../../../css/vote-modal.css";

import { UserVoteButtons } from "./UserVoteButtons";
import { ExtraFields } from "./extra-fields";
import { buildValidationSchema } from "./schema.helpers";
import { connect } from "react-redux";

import InputMask from "react-input-mask";
import { NavLink } from "react-router-dom";
import { RouteUrls } from "../../../../configs/routeUrls";

const HandleFormValues = ({ values, setFieldValue }) => {
  useEffect(() => {
    if (values.terytCity) {
      setFieldValue("terytProvince", {
        id: values.terytCity.provinceId,
        label: values.terytCity.parentProvinceConcatenatedName,
        value: values.terytCity.parentProvinceId,
        name: values.terytCity.provinceName,
      });
      setFieldValue("terytDistrict", {
        id: values.terytCity.districtId,
        label: values.terytCity.parentDistrictConcatenatedName,
        value: values.terytCity.parentDistrictId,
        name: values.terytCity.districtName,
      });
      setFieldValue("terytCommune", {
        id: values.terytCity.communeId,
        label: values.terytCity.parentCommuneConcatenatedName,
        value: values.terytCity.parentCommuneId,
        name: values.terytCity.communeName,
      });
    }
  }, [values.terytCity]);

  return null;
};

const UserVote = ({ app, agreementHistoryId, ...props }) => {
  const {
    uniqueEmailWhileVotingNotLoggedUser,
    disabled,
    clauseId,
    clauseText,
    onlyForLegalAge,
    availableStreetFeatures,
    availableDistricts,
    saveUser,
    onCancel,
    systemParameters,
    consultationForms,
    requireDistrict,
  } = props;

  const isDistrictHidden = !requireDistrict;

  const {
    usePeselForNotLogged,
    useTeryt,
    cacheAdditionalFields,
    enabledCacheAdditionalFields,
  } = systemParameters || {};

  const [initialValues] = useState({
    userSex: UserSex.NotSetted.value,
    firstname: "",
    surname: "",
    birthDate: undefined,
    city: "",
    districtId: null,
    postCode: "",
    streetFeature: StreetFeatureDropdownOption.NotSetted,
    street: "",
    number: "",
    flat: "",
    pesel: "",
    email: "",
    uniqueEmailWhileVotingNotLoggedUser,
    province: null,
    district: null,
    useTeryt,
    usePeselForNotLogged,
    clauseId,
    onlyForLegalAge,
    terytProvince: null,
    terytDistrict: null,
    terytCommune: null,
    terytCity: null,
    terytStreet: null,
    enabledCacheAdditionalFields,
  });

  const [provinces, setProvinces] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [communes, setCommunes] = useState([]);
  const [cities, setCities] = useState([]);
  const [streets, setStreets] = useState([]);

  const [currentProvince, setCurrentProvince] = useState(null);

  const [currentDistrictValue, setCurrentDistrictValue] = useState("");
  const [currentDistrict, setCurrentDistrict] = useState(null);

  const [currentCommuneValue, setCurrentCommuneValue] = useState("");
  const [currentCommune, setCurrentCommune] = useState(null);

  const [currentCityValue, setCurrentCityValue] = useState("");
  const [currentCity, setCurrentCity] = useState(null);

  const [currentStreetValue, setCurrentStreetValue] = useState("");

  const getCityFilters = () =>
    [
      {
        columnName: "provinceId",
        operation: "equal",
        value: currentProvince ? currentProvince.id : null,
      },
      {
        columnName: "districtId",
        operation: "equal",
        value: currentDistrict ? currentDistrict.id : null,
      },
      {
        columnName: "communeId",
        operation: "equal",
        value: currentCommune ? currentCommune.id : null,
      },
      {
        columnName: "elementType",
        operation: "equal",
        value: 16,
      },
      {
        columnName: "cityName",
        operation: "contains",
        value: currentCityValue,
      },
    ].filter((filter) => filter.value && filter);

  const minLengthToFilterValue = 3;

  const clearOptionsWhenProvinceChange = () => {
    setDistricts([]);
    setCommunes([]);
    setCities([]);
    setStreets([]);
  };

  const clearOptionsWhenDistrictChange = () => {
    setCommunes([]);
    setCities([]);
    setStreets([]);
  };

  const clearOptionsWhenCommuneChange = () => {
    setCities([]);
    setStreets([]);
  };

  const clearOptionsWhenCityChange = () => {
    setStreets([]);
  };

  const { loading: loadingProvinces } = useFetch({
    url: `${app.aswApi}/api/teryts/teryt-entries/v2`,
    queryParams: {
      size: 0,
      filters: [
        {
          columnName: "elementType",
          operation: "equal",
          value: 2,
        },
      ],
      sortings: [
        {
          columnName: "concatenatedName",
          direction: "asc",
        },
      ],
    },
    onCompleted: ({ items }) => {
      const processedItems = items.map(
        ({ provinceId, id, provinceName, concatenatedName }) => ({
          id: provinceId,
          label: concatenatedName,
          value: id,
          name: provinceName,
        })
      );

      setProvinces(processedItems);
    },
    skip: !useTeryt,
  });

  const { loading: loadingDistricts } = useFetch({
    url: `${app.aswApi}/api/teryts/teryt-entries/v2`,
    queryParams: {
      size: 0,
      filters: [
        {
          columnName: "provinceId",
          operation: "equal",
          value: currentProvince ? currentProvince.id : null,
        },
        {
          columnName: "elementType",
          operation: "equal",
          value: 4,
        },
        {
          columnName: "districtName",
          operation: "contains",
          value: currentDistrictValue,
        },
      ],
      sortings: [
        {
          columnName: "concatenatedName",
          direction: "asc",
        },
      ],
    },
    onCompleted: ({ items }) => {
      const processedItems = items.map(
        ({ districtId, concatenatedName, districtName, id }) => ({
          id: districtId,
          label: concatenatedName,
          value: id,
          name: districtName,
        })
      );

      setDistricts(processedItems);
    },
    skip:
      !useTeryt ||
      !currentProvince ||
      currentDistrictValue.length < minLengthToFilterValue,
  });

  const { loading: loadingCommunes } = useFetch({
    url: `${app.aswApi}/api/teryts/teryt-entries/v2`,
    queryParams: {
      size: 0,
      filters: [
        {
          columnName: "districtId",
          operation: "equal",
          value: currentDistrict ? currentDistrict.id : null,
        },
        {
          columnName: "elementType",
          operation: "equal",
          value: 8,
        },
        {
          columnName: "communeName",
          operation: "contains",
          value: currentCommuneValue,
        },
      ],
      sortings: [
        {
          columnName: "concatenatedName",
          direction: "asc",
        },
      ],
    },
    onCompleted: ({ items }) => {
      const processedItems = items.map(
        ({ communeId, concatenatedName, communeName, id }) => {
          return {
            id: communeId,
            label: concatenatedName,
            value: id,
            name: communeName,
          };
        }
      );

      setCommunes(processedItems);
    },
    skip:
      !useTeryt ||
      !currentDistrict ||
      currentCommuneValue.length < minLengthToFilterValue,
  });

  const { loading: loadingCities } = useFetch({
    url: `${app.aswApi}/api/teryts/teryt-entries/v2`,
    queryParams: {
      size: 0,
      filters: getCityFilters(),
      sortings: [
        {
          columnName: "concatenatedName",
          direction: "asc",
        },
      ],
    },
    onCompleted: ({ items }) => {
      const processedItems = items.map((item) => ({
        ...item,
        id: item.cityId,
        label: item.concatenatedName,
        value: item.id,
        name: item.cityName,
      }));

      setCities(processedItems);
    },
    skip: !useTeryt || currentCityValue.length !== minLengthToFilterValue,
  });

  const { loading: loadingStreets } = useFetch({
    url: `${app.aswApi}/api/teryts/teryt-entries/v2`,
    queryParams: {
      size: 0,
      filters: [
        {
          columnName: "cityId",
          operation: "equal",
          value: currentCity ? currentCity.id : null,
        },
        {
          columnName: "elementType",
          operation: "equal",
          value: 32,
        },
        {
          columnName: "streetName",
          operation: "contains",
          value: currentStreetValue,
        },
      ],
      sortings: [
        {
          columnName: "concatenatedName",
          direction: "asc",
        },
      ],
    },
    onCompleted: ({ items }) => {
      const processedItems = items.map(
        ({ streetId, concatenatedName, streetName, id }) => ({
          id: streetId,
          label: concatenatedName,
          value: id,
          name: streetName,
        })
      );

      setStreets(processedItems);
    },
    skip:
      !useTeryt ||
      !currentCity ||
      currentStreetValue.length < minLengthToFilterValue,
  });

  const baseSchema = UserVoteSchema({
    isDistrictHidden,
    isZipCodeRequiredWhileVotingNotLoggedUser:
      systemParameters.isZipCodeRequiredWhileVotingNotLoggedUser,
  });

  const validationSchema = useMemo(
    () =>
      buildValidationSchema(
        baseSchema,
        cacheAdditionalFields,
        enabledCacheAdditionalFields
      ),
    [baseSchema, cacheAdditionalFields, enabledCacheAdditionalFields]
  );

  const onSubmit = async (values, validateForm) => {
    const errors = await validateForm();

    if (Object.keys(errors).length > 0) return;

    const districtId = isDistrictHidden
      ? consultationForms[0].district.id
      : values.districtId.value;

    const currentValues = values.useTeryt
      ? {
          ...values,
          city: values.terytCity.label,
          street: values.terytStreet ? values.terytStreet.label : null,
          districtId,
        }
      : {
          ...values,
          districtId,
        };

    saveUser(currentValues);
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      validateOnChange={false}
      validateOnBlur={false}
    >
      {({
        values,
        errors,
        setFieldValue,
        handleBlur,
        handleChange,
        validateForm,
      }) => {
        return (
          <Form
            noValidate
            method="post"
            onSubmit={(e) => {
              e.preventDefault();

              onSubmit(values, validateForm);
            }}
          >
            <div className="box">
              <div className="container margin-top-20">
                <p className="margin-bottom-20">
                  Głosowanie w ramach budżetu obywatelskiego wymaga podania
                  informacji o osobie oddającej głos, niezbędnych do
                  przeprowadzenia samego głosowania jak i weryfikacji
                  poprawności oddanego głosu. Proszę o uzupełnienie informacji
                  lub zalogowanie się na konto użytkownika.
                </p>
                <Form.Row className="row row--justify-space">
                  <Form.Group className="row__element row__element--width-30">
                    <div className="field field--input">
                      <p
                        style={{
                          visibility: "hidden",
                          width: "0px",
                          height: "0px",
                          display: "none",
                        }}
                        id="aria-userSex"
                      >
                        Forma grzecznościowa
                      </p>

                      <Form.Label htmlFor={`userSex`} className="field__label">
                        Forma grzecznościowa*
                      </Form.Label>
                      <Select
                        id={`userSex`}
                        name={`userSex`}
                        options={[
                          {
                            value: UserSex.NotSetted.value,
                            text: "Wybierz...",
                          },
                          {
                            value: UserSex.Male.value,
                            text: "Pan",
                          },
                          {
                            value: UserSex.Female.value,
                            text: "Pani",
                          },
                        ]}
                        disabled={peselValidator(values.pesel)}
                        isInvalid={!!errors.userSex}
                        value={values.userSex}
                        onSelect={(_) => {
                          setFieldValue(`userSex`, _.value);
                        }}
                      />
                    </div>
                    {typeof errors.userSex === "string" && (
                      <Form.Control.Feedback
                        style={{ display: "inline" }}
                        type="invalid"
                        className="field--invalid d-flex"
                      >
                        {errors.userSex}
                      </Form.Control.Feedback>
                    )}
                  </Form.Group>
                  <Form.Group className="row__element row__element--width-30">
                    <div className="field field--input">
                      <p
                        style={{
                          visibility: "hidden",
                          width: "0px",
                          height: "0px",
                          display: "none",
                        }}
                        id="aria-firstname"
                      >
                        Imię użytkownika niezalogowanego
                      </p>
                      <Form.Label
                        htmlFor={`firstname`}
                        className="field__label"
                      >
                        Imię*
                      </Form.Label>
                      <Form.Control
                        disabled={disabled}
                        id={`firstname`}
                        name={`firstname`}
                        value={values.firstname}
                        onChange={(_) =>
                          setFieldValue(_.target.name, _.target.value)
                        }
                        onBlur={handleBlur}
                        className="field__input"
                        placeholder="Imię"
                        title=""
                        isInvalid={!!errors.firstname}
                        autocomplete="off"
                        aria-labelledby="aria-firstname"
                      />
                    </div>
                    <Form.Control.Feedback
                      type="invalid"
                      className="field--invalid d-flex"
                    >
                      {errors.firstname}
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group className="row__element row__element--width-30">
                    <div className="field field--input">
                      <p
                        style={{
                          visibility: "hidden",
                          width: "0px",
                          height: "0px",
                          display: "none",
                        }}
                        id="aria-surname"
                      >
                        Nazwisko użytkownika niezalogowanego
                      </p>
                      <Form.Label htmlFor={`surname`} className="field__label">
                        Nazwisko*
                      </Form.Label>
                      <Form.Control
                        disabled={disabled}
                        id={`surname`}
                        name={`surname`}
                        value={values.surname}
                        onChange={(_) =>
                          setFieldValue(_.target.name, _.target.value)
                        }
                        className="field__input"
                        placeholder="Nazwisko"
                        title=""
                        isInvalid={!!errors.surname}
                        autocomplete="off"
                        aria-labelledby="aria-surname"
                      />
                    </div>
                    <Form.Control.Feedback
                      type="invalid"
                      className="field--invalid d-flex"
                    >
                      {errors.surname}
                    </Form.Control.Feedback>
                  </Form.Group>
                  {usePeselForNotLogged ? (
                    <Form.Group className="row__element row__element--width-45">
                      <div className="field field--input">
                        <p
                          style={{
                            visibility: "hidden",
                            width: "0px",
                            height: "0px",
                            display: "none",
                          }}
                          id="aria-pesel"
                        >
                          Pesel użytkownika
                        </p>
                        <Form.Label htmlFor={`pesel`} className="field__label">
                          Pesel*
                        </Form.Label>
                        <Form.Control
                          disabled={disabled}
                          id={`pesel`}
                          name={`pesel`}
                          value={values.pesel}
                          onChange={(_) => {
                            if (
                              !!_.target.value.length &&
                              peselValidator(_.target.value)
                            ) {
                              const birthDate =
                                getBirthdateFromPesel(_.target.value) || null;

                              setFieldValue("birthDate", birthDate);

                              const isFemale = _.target.value[9] % 2 === 0;
                              const sexValue = isFemale
                                ? UserSex.Female.value
                                : UserSex.Male.value;

                              setFieldValue("userSex", sexValue);
                            }

                            setFieldValue(_.target.name, _.target.value);
                          }}
                          className="field__input"
                          placeholder="pesel"
                          title=""
                          isInvalid={!!errors.pesel}
                          autocomplete="off"
                          aria-labelledby="aria-pesel"
                        />
                      </div>
                      <Form.Control.Feedback
                        type="invalid"
                        className="field--invalid d-flex"
                      >
                        {errors.pesel}
                      </Form.Control.Feedback>
                    </Form.Group>
                  ) : null}
                  <Form.Group className="row__element row__element--width-45">
                    <div className="field field--input">
                      <p
                        style={{
                          visibility: "hidden",
                          width: "0px",
                          height: "0px",
                          display: "none",
                        }}
                        id="aria-birthDate"
                      >
                        Data urodzenia użytkownika niezalogowanego
                      </p>
                      <Form.Label
                        htmlFor={`birthDate`}
                        className="field__label"
                      >
                        Data urodzenia*
                      </Form.Label>
                      <Form.Control
                        type="date"
                        max="2070-12-31"
                        disabled={peselValidator(values.pesel) || disabled}
                        id={`birthDate`}
                        name={`birthDate`}
                        value={values.birthDate}
                        onChange={(_) =>
                          setFieldValue(_.target.name, _.target.value)
                        }
                        className="field__input"
                        placeholder="Data urodzenia"
                        title=""
                        isInvalid={!!errors.birthDate}
                        autocomplete="off"
                        aria-labelledby="aria-birthDate"
                      />
                    </div>
                    <Form.Control.Feedback
                      type="invalid"
                      className="field--invalid d-flex"
                    >
                      {errors.birthDate}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Form.Row>
              </div>

              <div className="container margin-top-10 margin-bottom-20">
                <Form.Row className="row row--justify-space  row--gap">
                  {isDistrictHidden ? null : (
                    <Form.Group className="row__element row__element--width-100">
                      <div className="field field--input">
                        <p
                          style={{
                            visibility: "hidden",
                            width: "0px",
                            height: "0px",
                            display: "none",
                          }}
                          id="aria-district"
                        >
                          Obszar użytkownika niezalogowanego
                        </p>
                        <Form.Label
                          htmlFor={`districtId`}
                          className="field__label"
                        >
                          Obszar*
                        </Form.Label>
                        <ReactSelect
                          {...{
                            name: "districtId",
                            options: [
                              ...availableDistricts
                                .filter(
                                  (availableDistricts) =>
                                    availableDistricts.id !== SystemDistrict &&
                                    !availableDistricts.isDeleted
                                )
                                .map((district) => ({
                                  label: district.name,
                                  value: district.id,
                                })),
                            ],
                            value: values.districtId,
                            setFieldValue,
                            placeholder: "Wybierz...",
                            isError: errors.districtId,
                          }}
                        />
                      </div>
                      {typeof errors.districtId === "string" && (
                        <Form.Control.Feedback
                          type="invalid"
                          className="field--invalid d-flex"
                        >
                          {errors.districtId}
                        </Form.Control.Feedback>
                      )}
                    </Form.Group>
                  )}
                  {useTeryt ? (
                    <Form.Group className="row__element row__element--width-45">
                      <div className="field field--input">
                        <p
                          style={{
                            visibility: "hidden",
                            width: "0px",
                            height: "0px",
                            display: "none",
                          }}
                          id="aria-province"
                        >
                          Województwo
                        </p>
                        <Form.Label
                          htmlFor={`terytProvince`}
                          className="field__label"
                        >
                          Województwo
                        </Form.Label>
                        <ReactSelect
                          {...{
                            name: "terytProvince",
                            options: provinces,
                            value: values.terytProvince,
                            placeholder: "Wstaw...",
                            clearInputsWhenChange: [
                              { key: "terytDistrict", value: null },
                              { key: "terytCommune", value: null },
                              { key: "terytCity", value: null },
                              { key: "terytStreet", value: null },
                            ],
                            setValue: setCurrentProvince,
                            noOptionsMessage: loadingProvinces
                              ? "Wczytywanie..."
                              : "Brak opcji do wyboru",
                            setFieldValue,
                            isError: errors.terytProvince,
                            clearStatesWhenInputChange:
                              clearOptionsWhenProvinceChange,
                          }}
                        />
                      </div>
                      {typeof errors.terytProvince === "string" && (
                        <Form.Control.Feedback
                          type="invalid"
                          className="field--invalid d-flex"
                        >
                          {errors.terytProvince}
                        </Form.Control.Feedback>
                      )}
                    </Form.Group>
                  ) : null}
                  {useTeryt ? (
                    <Form.Group className="row__element row__element--width-45">
                      <div className="field field--input">
                        <p
                          style={{
                            visibility: "hidden",
                            width: "0px",
                            height: "0px",
                            display: "none",
                          }}
                          id="aria-province"
                        >
                          Powiat
                        </p>

                        <Form.Label
                          htmlFor={`terytDistrict`}
                          className="field__label"
                        >
                          Powiat
                        </Form.Label>
                        <ReactSelect
                          {...{
                            name: "terytDistrict",
                            options: districts,
                            value: values.terytDistrict,
                            placeholder:
                              "Wpisz min. 3 litery, aby dokonać wyboru",
                            getInputChange: setCurrentDistrictValue,
                            setValue: setCurrentDistrict,
                            clearInputsWhenChange: [
                              { key: "terytCommune", value: null },
                              { key: "terytCity", value: null },
                              { key: "terytStreet", value: null },
                            ],
                            noOptionsMessage: loadingDistricts
                              ? "Wczytywanie..."
                              : "Brak opcji do wyboru",
                            setFieldValue,
                            isError: errors.terytDistrict,
                            clearStatesWhenInputChange:
                              clearOptionsWhenDistrictChange,
                          }}
                        />
                      </div>
                      {typeof errors.terytDistrict === "string" && (
                        <Form.Control.Feedback
                          type="invalid"
                          className="field--invalid d-flex"
                        >
                          {errors.terytDistrict}
                        </Form.Control.Feedback>
                      )}
                    </Form.Group>
                  ) : null}
                  {useTeryt ? (
                    <Form.Group className="row__element row__element--width-45">
                      <div className="field field--input">
                        <p
                          style={{
                            visibility: "hidden",
                            width: "0px",
                            height: "0px",
                            display: "none",
                          }}
                          id="aria-commune"
                        >
                          Gmina
                        </p>

                        <Form.Label
                          htmlFor={`terytCommune`}
                          className="field__label"
                        >
                          Gmina
                        </Form.Label>
                        <ReactSelect
                          {...{
                            name: "terytCommune",
                            options: communes,
                            value: values.terytCommune,
                            placeholder:
                              "Wpisz min. 3 litery, aby dokonać wyboru",
                            getInputChange: setCurrentCommuneValue,
                            setValue: setCurrentCommune,
                            clearInputsWhenChange: [
                              { key: "terytCity", value: null },
                              { key: "terytStreet", value: null },
                            ],
                            noOptionsMessage: loadingCommunes
                              ? "Wczytywanie..."
                              : "Brak opcji do wyboru",
                            setFieldValue,
                            isError: errors.terytCommune,
                            clearStatesWhenInputChange:
                              clearOptionsWhenCommuneChange,
                          }}
                        />
                      </div>
                      {typeof errors.terytCommune === "string" && (
                        <Form.Control.Feedback
                          type="invalid"
                          className="field--invalid d-flex"
                        >
                          {errors.terytCommune}
                        </Form.Control.Feedback>
                      )}
                    </Form.Group>
                  ) : null}
                  {useTeryt ? (
                    <Form.Group className="row__element row__element--width-45">
                      <div className="field field--input">
                        <p
                          style={{
                            visibility: "hidden",
                            width: "0px",
                            height: "0px",
                            display: "none",
                          }}
                          id="aria-city"
                        >
                          Miejscowość
                        </p>

                        <Form.Label
                          htmlFor={`terytCity`}
                          className="field__label"
                        >
                          Miejscowość*
                        </Form.Label>
                        <ReactSelect
                          {...{
                            name: "terytCity",
                            options: cities,
                            value: values.terytCity,
                            placeholder:
                              "Wpisz min. 3 litery, aby dokonać wyboru",
                            getInputChange: setCurrentCityValue,
                            setValue: setCurrentCity,
                            clearInputsWhenChange: [
                              { key: "terytStreet", value: null },
                            ],
                            noOptionsMessage: loadingCities
                              ? "Wczytywanie..."
                              : "Brak opcji do wyboru",
                            setFieldValue,
                            isError: errors.terytCity,
                            clearStatesWhenInputChange:
                              clearOptionsWhenCityChange,
                          }}
                        />
                      </div>
                      {typeof errors.terytCity === "string" && (
                        <Form.Control.Feedback
                          type="invalid"
                          className="field--invalid d-flex"
                        >
                          {errors.terytCity}
                        </Form.Control.Feedback>
                      )}
                    </Form.Group>
                  ) : (
                    <Form.Group className="row__element row__element--width-45">
                      <div className="field field--input">
                        <p
                          style={{
                            visibility: "hidden",
                            width: "0px",
                            height: "0px",
                            display: "none",
                          }}
                          id="aria-city"
                        >
                          Miejscowość użytkownika niezalogowanego
                        </p>
                        <Form.Label htmlFor={`city`} className="field__label">
                          Miejscowość*
                        </Form.Label>
                        <Form.Control
                          disabled={disabled}
                          id={`city`}
                          name={`city`}
                          value={values.city}
                          onChange={(_) =>
                            setFieldValue(_.target.name, _.target.value)
                          }
                          className="field__input"
                          placeholder="Miejscowość"
                          title=""
                          isInvalid={!!errors.city}
                          autocomplete="off"
                          aria-labelledby="aria-city"
                        />
                      </div>
                      <Form.Control.Feedback
                        type="invalid"
                        className="field--invalid d-flex"
                      >
                        {errors.city}
                      </Form.Control.Feedback>
                    </Form.Group>
                  )}
                  <Form.Group className="row__element row__element--width-45">
                    <div className="field field--input">
                      <p
                        style={{
                          visibility: "hidden",
                          width: "0px",
                          height: "0px",
                          display: "none",
                        }}
                        id="aria-postCode"
                      >
                        Kod pocztowy użytkownika niezalogowanego
                      </p>
                      <Form.Label htmlFor={`postCode`} className="field__label">
                        Kod pocztowy*
                      </Form.Label>
                      <InputMask
                        disabled={disabled}
                        id={`postCode`}
                        name={`postCode`}
                        value={values.postCode}
                        onChange={(_) =>
                          setFieldValue(_.target.name, _.target.value)
                        }
                        className="field__input form-control"
                        placeholder="Kod pocztowy"
                        autocomplete="off"
                        aria-labelledby="aria-postCode"
                        mask="99-999"
                        showMask
                        maskChar="_"
                        style={
                          errors.postCode ? { border: "1px solid red" } : {}
                        }
                      />
                    </div>
                    <Form.Control.Feedback
                      type="invalid"
                      className="field--invalid d-flex"
                    >
                      {errors.postCode}
                    </Form.Control.Feedback>
                  </Form.Group>
                  {!useTeryt ? (
                    <Form.Group className="row__element row__element--width-45">
                      <div className="field field--input">
                        <p
                          style={{
                            visibility: "hidden",
                            width: "0px",
                            height: "0px",
                            display: "none",
                          }}
                          id="aria-streetFeature"
                        >
                          Cecha ulicy użytkownika niezalogowanego
                        </p>
                        <Form.Label
                          htmlFor={`streetFeature`}
                          className="field__label"
                        >
                          Cecha ulicy
                        </Form.Label>
                        <Select
                          id={`streetFeature`}
                          name={`streetFeature`}
                          options={[
                            {
                              value: StreetFeatureDropdownOption.NotSetted,
                              text: "Wybierz...",
                            },
                            ...map(availableStreetFeatures, (_) => ({
                              value: _.id,
                              text: _.name,
                            })),
                          ]}
                          value={values.streetFeature}
                          onSelect={(_) => {
                            setFieldValue(`streetFeature`, _.value);
                          }}
                        />
                      </div>
                      {typeof errors.streetFeature === "string" && (
                        <Form.Control.Feedback
                          type="invalid"
                          className="field--invalid d-flex"
                        >
                          {errors.streetFeature}
                        </Form.Control.Feedback>
                      )}
                    </Form.Group>
                  ) : null}
                  {useTeryt ? (
                    <Form.Group className="row__element row__element--width-45">
                      <div className="field field--input">
                        <p
                          style={{
                            visibility: "hidden",
                            width: "0px",
                            height: "0px",
                            display: "none",
                          }}
                          id="aria-street"
                        >
                          Ulica
                        </p>

                        <Form.Label
                          htmlFor={`terytStreet`}
                          className="field__label"
                        >
                          Ulica
                        </Form.Label>
                        <ReactSelect
                          {...{
                            name: "terytStreet",
                            options: streets,
                            value: values.terytStreet,
                            placeholder:
                              "Wpisz min. 3 litery, aby dokonać wyboru",
                            getInputChange: setCurrentStreetValue,
                            noOptionsMessage: loadingStreets
                              ? "Wczytywanie..."
                              : "Brak opcji do wyboru",
                            setFieldValue,
                            isError: errors.terytStreet,
                          }}
                        />
                      </div>
                      {typeof errors.terytStreet === "string" && (
                        <Form.Control.Feedback
                          type="invalid"
                          className="field--invalid d-flex"
                        >
                          {errors.terytStreet}
                        </Form.Control.Feedback>
                      )}
                    </Form.Group>
                  ) : (
                    <Form.Group className="row__element row__element--width-45">
                      <div className="field field--input">
                        <p
                          style={{
                            visibility: "hidden",
                            width: "0px",
                            height: "0px",
                            display: "none",
                          }}
                          id="aria-street"
                        >
                          Ulica użytkownika niezalogowanego
                        </p>
                        <Form.Label htmlFor={`street`} className="field__label">
                          Ulica
                        </Form.Label>
                        <Form.Control
                          disabled={disabled}
                          id={`street`}
                          name={`street`}
                          value={values.street}
                          onChange={(_) =>
                            setFieldValue(_.target.name, _.target.value)
                          }
                          className="field__input"
                          placeholder="Ulica"
                          title=""
                          isInvalid={!!errors.street}
                          autocomplete="off"
                          aria-labelledby="aria-street"
                        />
                      </div>
                      <Form.Control.Feedback
                        type="invalid"
                        className="field--invalid d-flex"
                      >
                        {errors.street}
                      </Form.Control.Feedback>
                    </Form.Group>
                  )}
                  <Form.Group className="row__element row__element--width-45">
                    <div className="field field--input">
                      <p
                        style={{
                          visibility: "hidden",
                          width: "0px",
                          height: "0px",
                          display: "none",
                        }}
                        id="aria-number"
                      >
                        Numer budynku użytkownika niezalogowanego
                      </p>
                      <Form.Label htmlFor={`number`} className="field__label">
                        Numer budynku*
                      </Form.Label>
                      <Form.Control
                        disabled={disabled}
                        id={`number`}
                        name={`number`}
                        value={values.number}
                        onChange={(_) =>
                          setFieldValue(_.target.name, _.target.value)
                        }
                        className="field__input"
                        placeholder="Numer budynku"
                        title=""
                        isInvalid={!!errors.number}
                        autocomplete="off"
                        aria-labelledby="aria-number"
                      />
                    </div>
                    <Form.Control.Feedback
                      type="invalid"
                      className="field--invalid d-flex"
                    >
                      {errors.number}
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group className="row__element row__element--width-45">
                    <div className="field field--input">
                      <p
                        style={{
                          visibility: "hidden",
                          width: "0px",
                          height: "0px",
                          display: "none",
                        }}
                        id="aria-flat"
                      >
                        Numer lokalu użytkownika niezalogowanego
                      </p>
                      <Form.Label htmlFor={`flat`} className="field__label">
                        Numer lokalu
                      </Form.Label>
                      <Form.Control
                        disabled={disabled}
                        id={`flat`}
                        name={`flat`}
                        value={values.flat}
                        onChange={(_) =>
                          setFieldValue(_.target.name, _.target.value)
                        }
                        className="field__input"
                        placeholder="Numer lokalu"
                        title=""
                        isInvalid={!!errors.flat}
                        autocomplete="off"
                        aria-labelledby="aria-flat"
                      />
                    </div>
                    <Form.Control.Feedback
                      type="invalid"
                      className="field--invalid d-flex"
                    >
                      {errors.flat}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Form.Row>
              </div>

              <div className="container margin-top-20 margin-bottom-20">
                {values.uniqueEmailWhileVotingNotLoggedUser && (
                  <Form.Row className="row row--justify-space">
                    <Form.Group className="row__element row__element--full">
                      <div className="field field--input">
                        <p
                          style={{
                            visibility: "hidden",
                            width: "0px",
                            height: "0px",
                            display: "none",
                          }}
                          id="aria-email"
                        >
                          Adres e-mail użytkownika niezalogowanego
                        </p>
                        <Form.Label htmlFor={`email`} className="field__label">
                          Adres e-mail
                        </Form.Label>
                        <Form.Control
                          disabled={disabled}
                          id={`email`}
                          name={`email`}
                          value={values.email}
                          onChange={(_) =>
                            setFieldValue(_.target.name, _.target.value)
                          }
                          className="field__input"
                          placeholder="Adres e-mail"
                          title=""
                          isInvalid={!!errors.email}
                          autocomplete="off"
                          aria-labelledby="aria-email"
                        />
                      </div>
                      <Form.Control.Feedback
                        type="invalid"
                        className="field--invalid d-flex"
                      >
                        {errors.email}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Form.Row>
                )}
                <ExtraFields
                  {...{
                    errors,
                    extraFields: cacheAdditionalFields,
                    handleBlur,
                    handleChange,
                    includeExtraFields: enabledCacheAdditionalFields,
                    setFieldValue,
                    values,
                  }}
                />
                {values.clauseId && (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <Form.Row
                      className="row row--justify-space"
                      style={{
                        marginLeft: "0.1rem",
                      }}
                    >
                      <Form.Group className="row__element row__element--full">
                        <label className="checkbox">
                          <input
                            className="checkbox__input"
                            type="checkbox"
                            disabled={disabled}
                            id="clauseRequired"
                            name="clauseRequired"
                            value={values.clauseRequired}
                            checked={values.clauseRequired}
                            onChange={(_) =>
                              setFieldValue(_.target.name, _.target.checked)
                            }
                          />
                          <span className="row row--align-center row--nowrap">
                            <span className="checkbox__button checkbox__button-left margin-right-5">
                              <span className="checkbox__button-checkbox" />
                            </span>
                            <span className="text">
                              <div
                                dangerouslySetInnerHTML={{ __html: clauseText }}
                              />
                            </span>
                          </span>
                        </label>
                        {typeof errors.clauseRequired === "string" && (
                          <Form.Control.Feedback
                            type="invalid"
                            className="field--invalid d-flex"
                          >
                            {errors.clauseRequired}
                          </Form.Control.Feedback>
                        )}
                      </Form.Group>
                    </Form.Row>
                    {agreementHistoryId && (
                      <NavLink
                        to={`${RouteUrls.App.termOfUse}/${agreementHistoryId}`}
                        className="link"
                        target="_blank"
                        title="Szczegóły regulaminu"
                      >
                        <i
                          className="far fa-clone link__icon margin-left-10"
                          aria-hidden="true"
                        />
                      </NavLink>
                    )}
                  </div>
                )}
              </div>
              <UserVoteButtons
                {...{
                  onCancel,
                  disabled,
                }}
              />
            </div>
            <HandleFormValues {...{ values, setFieldValue }} />
          </Form>
        );
      }}
    </Formik>
  );
};

const mapStateToProps = (state) => {
  return {
    app: state.app,
    agreementHistoryId: state.project.project.agreementHistory
      ? state.project.project.agreementHistory.id
      : null,
  };
};

export default connect(mapStateToProps)(UserVote);
